export default "__VITE_ASSET__ginaz7bA__"